/**
 * Eine Maschinenzeichenkette, die umbrechen darf, ohne ihre Spalte zu sprengen.
 *
 * Die REGEL steht daneben in `bruchstellen.ts`, ohne JSX - dort lässt sie sich
 * ausrechnen, hier wird sie nur gezeichnet. Siehe den Kopf jener Datei für den
 * Befund vom 06.09.2026.
 */
import { bruchstuecke, brauchtBruch } from './bruchstellen.ts';

export default function Bruchtext({ text, abZeichen }:
  { text: string; abZeichen?: number }) {
  if (!brauchtBruch(text, abZeichen)) return <>{text}</>;
  const teile = bruchstuecke(text);
  return (
    <>
      {teile.map((s, i) => (
        /* `<wbr>` ist ein Element OHNE Inhalt: es sagt „hier darf umgebrochen
           werden" und schreibt nichts in den Text. Wer die Adresse markiert
           und kopiert, bekommt sie unverändert zurück. */
        <span key={i}>{s}{i < teile.length - 1 && <wbr />}</span>
      ))}
    </>
  );
}
